// Verifica que el hostname actual coincide con uno de los dominios
// permitidos de `fdPublicConfig.LOGIN_DOMAINS`. Mitiga ataques de
// phishing donde alguien clona la UI en otro dominio.
//
// Aceptamos exact match o subdominio (`*.facturadirecta.com`). Port 1:1
// del helper `validDomain` de keycloak.coffee.

import { getFdPublicConfig } from "./window";

export function validDomain(): boolean {
  const cfg = getFdPublicConfig();
  const allowList = (cfg.LOGIN_DOMAINS || "")
    .split(",")
    .map((d) => d.trim())
    .filter(Boolean);
  const hostname = window.location.hostname;
  return allowList.some(
    (domain) => hostname === domain || hostname.endsWith("." + domain),
  );
}
